<template>
  <div class="dataStatistics" v-loading="isLoading">
    <a-modal
      v-model="templateModalVisible"
      :title="templateModalTitle"
      :confirm-loading="templateModalLoading"
      :after-close="clearTemplateForm"
      @ok="submitTemplate"
    >
      <a-form-model
        style="margin-top: -20px;"
        ref="templateForm"
        :model="templateForm"
        :rules="templateRules"
      >
        <a-form-model-item :label="$t('dataReport.priority')" required>
          <a-input-number v-model="templateForm.sort" />
        </a-form-model-item>
        <a-form-model-item :label="$t('dataReport.templateName')" prop="name">
          <a-input style="padding-left: 10px; background-color: unset" :placeholder="$t('placeholder.templateName')" v-model="templateForm.name" />
        </a-form-model-item>
        <a-form-model-item :label="$t('station.LLJ')" prop="flowmeter">
          <a-select mode="tags" style="width: 100%;" :placeholder="$t('placeholder.device')" v-model="templateForm.flowmeter">
            <a-select-option v-for="device in flowmeterList" :key="device.code">
              {{ device.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('station.DB')" prop="elctricitymeter">
          <a-select mode="tags" style="width: 100%;" :placeholder="$t('placeholder.device')" v-model="templateForm.elctricitymeter">
            <a-select-option v-for="device in electricityMeterList" :key="device.code">
              {{ device.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('dataReport.gasElectricRatio')">
          <a-input-number style="width: 100%;" v-model="templateForm.gasElectricRatio" />
        </a-form-model-item>
        <a-form-model-item :label="$t('common.pressure')">
          <a-select style="width: 50%;" :placeholder="$t('placeholder.device')" v-model="templateForm.pressureDeviceCode" @change="getPoints">
            <a-select-option v-for="device in deviceList" :key="device.code">
              {{ device.name }}
            </a-select-option>
          </a-select>
          <a-select style="width: 50%;" :placeholder="$t('placeholder.points')" v-model="templateForm.pressureParamCode">
            <a-select-option v-for="device in pressurePoints" :key="device.code">
              {{ device.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('common.startTime')">
          <a-date-picker v-model="templateForm.startTime" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      v-model="exportParamsModalVisible"
      :width="600"
      :title="$t('buttons.export')"
      :confirm-loading="isExporting"
      @ok="exportToExcel"
    >
      <a-form-model :labelCol="{ span: 6 }" :wrapperCol="{ span: 18 }">
        <a-form-model-item :label="$t('common.startTime')">
          <a-date-picker style="width: 300px;" v-model="exportForm.startDate" />
        </a-form-model-item>
        <a-form-model-item :label="$t('common.endTime')">
          <a-date-picker style="width: 300px;" v-model="exportForm.endDate" />
        </a-form-model-item>
        <a-form-model-item :label="$t('dataReport.exportColumns')">
          <a-checkbox-group v-model="exportForm.columns">
            <a-checkbox v-for="(v, k) in exportColumns" :key="k" :value="k">
              {{ v }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      v-model="isRemarkShow"
      :width="641"
      :title="$t('dataReport.calculation')"
      @ok="isRemarkShow = false"
    >
      <ul class="remarkUl">
        <li
          v-for="r in remarkList[lang]"
          :key="r.label"
        >
          <i>{{ r.label }}</i>{{ r.content }}
        </li>
      </ul>
    </a-modal>

    <div class="title">
      <h1 class="stationName">{{ stationName }}</h1>
      <ul class="models">
        <li
          v-for="(m, i) in models"
          :key="m.id"
          :class="{ active: activeModelIndex === i }"
          @click.stop="selectModel(i)"
        >
          {{ m.name }}
        </li>
      </ul>
      <div class="buttons_group">
        <a-button type="primary" @click="showTemplateModal('add')">
          {{ $t("dataReport.addTemplate") }}
        </a-button>
        <a-button v-show="activeModelIndex" type="primary" @click="showTemplateModal('edit')">
          {{ $t("dataReport.editTemplate") }}
        </a-button>
        <a-button v-show="activeModelIndex" type="primary" @click="confirmToDeleteModel">
          {{ $t("dataReport.deleteTemplate") }}
        </a-button>
      </div>
    </div>

    <ul class="headerNav">
      <li :class="{ fold: isFlowmeterFold }" v-if="isFlowmeterShow">
        <header>
          <h3>{{ $t("station.LLJ") }}</h3>
          <span @click="changeNavFold('FlowmeterFold')">
            {{ isFlowmeterFoldMessage }}
            <a-icon type="double-right" v-show="isFlowmeterFold" />
            <a-icon type="double-left" v-show="!isFlowmeterFold" />
          </span>
          <div class="border"></div>
        </header>
        <section class="nav_body" v-show="!isFlowmeterFold">
          <ul>
            <li
              v-for="f in flowmeterList"
              :key="f.code"
              :title="f.title"
            >
              <label :for="f.code">
                <span :title="f.name" class="device_name">
                  {{ f.name.slice(0, 9) }}
                </span>
                <input
                  v-model="f.selected"
                  :id="f.code"
                  type="checkbox"
                />
              </label>
            </li>
          </ul>
        </section>
      </li>
      <li :class="{ fold: isEletricitymeterFold }" :style="{ width: isFlowmeterShow ? '50%' : '100%' }">
        <header>
          <h3>{{ $t("station.DB") }}</h3>
          <span @click="changeNavFold('EletricitymeterFold')">
            {{ isEletricitymeterFoldMessage }}
            <a-icon type="double-right" v-show="isEletricitymeterFold" />
            <a-icon type="double-left" v-show="!isEletricitymeterFold" />
          </span>
          <div class="border"></div>
        </header>
        <section class="nav_body" v-show="!isEletricitymeterFold">
          <ul>
            <li
              v-for="e in electricityMeterList"
              :key="e.code"
              :title="e.title"
            >
              <label :for="e.code">
                <span :title="e.name" class="device_name">
                  {{ e.name.slice(0, 9) }}
                </span>
                <input
                  v-model="e.selected"
                  :id="e.code"
                  type="checkbox"
                />
              </label>
            </li>
          </ul>
        </section>
      </li>
    </ul>

    <section class="content">
      <div class="search">
        <span
          v-for="c in categories"
          :key="c.key"
          :class="{ active: c.key === activeCategory }"
          @click="toggleCategory(c)"
        >
          {{ $t(c.text) }}
        </span>
        <el-date-picker
          v-show="activeCategory === 'day'"
          v-model="dayTimeValue"
          type="date"
          style="background-color: #2f3d4f"
          :key="lang"
          :clearable="false"
          @change="renderTableAndChart"
        />
        <el-date-picker
          v-show="activeCategory === 'month'"
          v-model="monthTimeValue"
          type="daterange"
          size="small"
          style="background-color: #2f3d4f"
          unlink-panels
          :key="lang + '1'"
          :clearable="false"
          :picker-options="pickerOptions"
          @change="renderTableAndChart"
        />
        <el-date-picker
          v-show="activeCategory === 'year'"
          v-model="yearTimeValue"
          type="daterange"
          size="small"
          style="background-color: #2f3d4f"
          unlink-panels
          :key="lang + '2'"
          :clearable="false"
          :picker-options="pickerOptions"
          @change="renderTableAndChart"
        />
        <div class="buttons">
          <a-button type="primary" @click="renderTableAndChart">{{ $t('buttons.search') }}</a-button>
          <a-button v-if="isExportable" type="primary" @click="showExportParamsModal">{{ $t('buttons.export') }}</a-button>
          <a-button type="primary" @click="showAggregate">{{ $t('device.distribution') }}</a-button>
        </div>
        <div class="right_buttons">
          <a-checkbox v-show="activeCategory !== 'year'" style="color: #fff; font-size: 16px;" v-model="flowPowerEnabled" @change="handleFlowPowerEnableChange">{{ $t("dataReport.checkeExtremeValue") }}</a-checkbox>
          <a-button style="margin-left: 15px;" type="primary" @click="isRemarkShow = true"> {{ $t("dataReport.calculation") }} </a-button>
        </div>
      </div>

      <div class="table_wrapper">
        <table>
          <thead>
            <tr>
              <th
                v-for="c in columns"
                v-show="c.visible"
                :key="c.key"
              >
                {{ c[lang] }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="t in tableData"
              :key="t.datetime"
            >
              <td>{{ t.datetime }}</td>
              <td v-if="isFlowmeterShow">{{ t.avgGasConsumption.toFixed(2) }}</td>
              <td v-if="isFlowmeterShow && flowPowerEnabled">{{ t.minFlow.toFixed(2) }}</td>
              <td v-if="isFlowmeterShow && flowPowerEnabled">{{ t.maxFlow.toFixed(2) }}</td>
              <td v-if="isFlowmeterShow">{{ t.flowMeterAccumulation.toFixed(2) }}</td>
              <td>{{ t.avgPower.toFixed(2) }}</td>
              <td v-if="flowPowerEnabled">{{ t.minPower.toFixed(2) }}</td>
              <td v-if="flowPowerEnabled">{{ t.maxPower.toFixed(2) }}</td>
              <td>{{ t.electricityMeterAccumulation.toFixed(2) }}</td>
              <td v-if="isFlowmeterShow">{{ t.avgPressure.toFixed(2) }}</td>
              <td v-if="isFlowmeterShow">{{ t.avgConsumption.toFixed(5) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="charts_group_wrapper">
        <ul class="type_toggler">
          <li :class="{ active: activeChartType === 'line' }" @click="toggleChartType('line')">{{ $t("line") }}</li>
          <li :class="{ active: activeChartType === 'bar' }" @click="toggleChartType('bar')">{{ $t("bar") }}</li>
        </ul>
        <ul class="charts_group">
          <li
            v-for="p in pointsOfCharts"
            :key="p.key"
          >
            <h3>{{ p.title[lang] }}</h3>
            <hr />
            <div class="chart_wrapper">
              <div class="tooltip">
                <p>{{ $t("min") }} {{ p.min }}</p>
                <p>{{ $t("max") }} {{ p.max }}</p>
              </div>
              <div class="chart" :id="p.key"></div>
            </div>
          </li>
        </ul>
        <div style="height: 50px;"></div>
      </div>
    </section>

    <div ref="aggregate" class="mask aggregate" @mousedown="startDrag" v-show="isAggregateVisible" v-loading="isAggregateLoading">
      <a-icon type="close" @click="clearAggregate" />
      <div class="wrapper" @mousedown.stop="">
        <header class="header">
          <h2 style="display: inline-block;">
            {{ stationName }}
          </h2>
          <ul class="models">
            <li
              v-for="(model, index) in models"
              :key="model.id"
              :class="{ active: activeModelIndex_aggregate === index }"
              @click.stop="selectModel_aggregate(index, model)"
            >{{ model.name }}</li>
          </ul>
        </header>
        <ul class="headerNav">
          <li :class="{ fold: isFlowmeterFold_aggregate }" v-if="isFlowmeterShow">
            <header>
              <h3>{{ $t("station.LLJ") }}</h3>
              <span @click="changeNavFold_aggregate('FlowmeterFold')">
                {{ isFlowmeterFoldMessage_aggregate }}
                <a-icon type="double-right" v-show="isFlowmeterFold_aggregate" />
                <a-icon type="double-left" v-show="!isFlowmeterFold_aggregate" />
              </span>
              <div class="border"></div>
            </header>
            <section class="nav_body" v-show="!isFlowmeterFold_aggregate">
              <ul>
                <li
                  v-for="f in flowmeterList_aggregate"
                  :key="f.code"
                  :title="f.title"
                >
                  <label :for="f.code + '_aggregate'">
                    <span :title="f.name" class="device_name">
                      {{ f.name.slice(0, 9) }}
                    </span>
                    <input
                      v-model="f.selected"
                      :id="f.code + '_aggregate'"
                      type="checkbox"
                    />
                  </label>
                </li>
              </ul>
            </section>
          </li>
          <li :class="{ fold: isEletricitymeterFold_aggregate }">
            <header>
              <h3>{{ $t("station.DB") }}</h3>
              <span @click="changeNavFold_aggregate('EletricitymeterFold')">
                {{ isEletricitymeterFoldMessage_aggregate }}
                <a-icon type="double-right" v-show="isEletricitymeterFold_aggregate" />
                <a-icon type="double-left" v-show="!isEletricitymeterFold_aggregate" />
              </span>
              <div class="border"></div>
            </header>
            <section class="nav_body" v-show="!isEletricitymeterFold_aggregate">
              <ul>
                <li
                  v-for="e in electricityMeterList_aggregate"
                  :key="e.code"
                  :title="e.title"
                >
                  <label :for="e.code + '_aggregate'">
                    <span :title="e.name" class="device_name">
                      {{ e.name.slice(0, 9) }}
                    </span>
                    <input
                      v-model="e.selected"
                      :id="e.code + '_aggregate'"
                      type="checkbox"
                    />
                  </label>
                </li>
              </ul>
            </section>
          </li>
        </ul>
        <div class="search">
          <el-date-picker
            type="datetimerange"
            size="small"
            style="background-color: #2f3d4f"
            v-model="aggregateTimeValue"
            :default-time="['00:00:00', '23:59:59']"
          />
          <label style="margin-left: 25px;">
            {{ $t("dataReport.points") }}: 
            <a-select dropdownClassName="selectOption" :placeholder="$t('messages.pedt')" style="width: 160px; margin-left: 6px;" v-model="selectedDeviceType" @change="handleDeviceTypeChange">
              <a-select-option
                v-for="t in deviceTypeOptions"
                :key="t.key"
              >
                {{ t.name }}
              </a-select-option>
            </a-select>
            <a-select dropdownClassName="selectOption" :placeholder="$t('device.selectPoints')" style="width: 140px; background-color: #2f3d4f; margin-left: 6px;" :notFoundContent="$t('common.nd')" :getPopupContainer="getPopupContainer" v-model="selectedPoint">
              <a-select-option
                v-for="f in pointsOptions"
                :key="f.code"
              >
                {{ f.name }}
              </a-select-option>
            </a-select>
          </label>
          <a-button type="primary" style="margin-left: 30px;" @click="addRange_aggregate">{{ $t("device.addRange") }}</a-button>
          <a-button v-show="ranges_aggregate.length" type="primary" style="margin-left: 10px;" @click="deleteLastRange">{{ $t("device.removeRange") }}</a-button>
          <a-button v-show="ranges_aggregate.length" type="primary" style="margin-left: 10px;" @click="analyse_aggregate" :loading="isAggregateAnalysing">{{ $t("device.analysis") }}</a-button>
        </div>
        <div class="content">
          <div class="left">
            <div class="top">
              <h3>{{ $t("device.range") }}: </h3>
              <ul class="ranges">
                <li
                  v-for="(r, i) in ranges_aggregate"
                  :key="r.id"
                >
                  <a-input v-model="r.min" style="width: 60px;" />
                  <span style="margin-left: 6px;">≤</span>
                  <span style="margin: 0 6px;">{{ $t("device.range") }}<span :class="{ ml: i < 9 }">{{ i + 1 }}</span></span>
                  <span style="margin-right: 6px;">&lt;</span>
                  <a-input v-model="r.max" style="width: 60px;" />
                </li>
              </ul>
            </div>
            <div class="bottom">
              <h3>{{ $t("dataReport.origin") }}: </h3>
              <div class="chart" id="origin"></div>
            </div>
          </div>
          <div class="right">
            <h3>{{ $t("dataReport.result") }}: </h3>
            <div class="chart" id="pie"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import zh from "element-ui/lib/locale/lang/zh-CN"
import en from "element-ui/lib/locale/lang/en"
import locale from "element-ui/lib/locale"
import moment from "moment"

import {
  setCompleteColumns,
  onlyDBColumns,
  setCompletePointsOfCharts,
  onlyDBPointsOfCharts,
  colors
} from "./data"
import {
  getDeviceGroup,
  getDayReport,
  updateDeviceGroup,
  getMonthReport,
  getYearReport,
  exportReport,
  exportReportM,
  exportReportY,
  getAggregateHistoryData
} from "@/api/device"
import { nanoid } from "nanoid"
import { getProtocol } from "@/api/protocol"

export default {
  data() {
    return {
      en,
      zh,
      stationName: "",
      models: [],
      activeModelIndex: 0,
      templateModalVisible: false,
      templateModalLoading: false,
      templateForm: {
        sort: 1,
        name: "",
        flowmeter: [],
        elctricitymeter: [],
        gasElectricRatio: undefined,
        pressureDeviceCode: "",
        pressureParamCode: "",
        startTime: ""
      },
      templateRules: {},
      flowmeterList: [],
      electricityMeterList: [],
      deviceList: [],
      pressurePoints: [],
      templateModalTitle: "",
      isFlowmeterShow: false,
      isFlowmeterFold: false,
      isEletricitymeterFold: false,
      isFlowmeterFoldMessage: "",
      isEletricitymeterFoldMessage: "",
      categories: [
        {
          key: "day",
          text: "dataReport.day"
        },
        {
          key: "month",
          text: "dataReport.month"
        },
        {
          key: "year",
          text: "dataReport.year"
        }
      ],
      activeCategory: "day",
      dayTimeValue: null,
      monthTimeValue: null,
      yearTimeValue: null,
      isExportable: false,
      exportParamsModalVisible: false,
      isExporting: false,
      exportForm: {
        startDate: "",
        endDate: "",
        columns: ["datetime", "avgGasConsumption", "flowMeterAccumulation", "avgPower", "electricityMeterAccumulation", "avgPressure", "avgConsumption"],
        unit: "Nm³"
      },
      exportColumns: {
        datetime: "",
        avgGasConsumption: "",
        flowMeterAccumulation: "",
        avgPower: "",
        electricityMeterAccumulation: "",
        avgPressure: "",
        avgConsumption: "",
        specificPower: ""
      },
      isRemarkShow: false,
      remarkList: {},
      isLoading: false,
      columns: [],
      tableData: [],
      activeChartType: "bar",
      pointsOfCharts: [],
      flowPowerEnabled: false,
      aggregateTimeValue: null,
      ranges_aggregate: [],
      isAggregateVisible: false,
      activeModelIndex_aggregate: 0,
      isFlowmeterFold_aggregate: false,
      isFlowmeterFoldMessage_aggregate: "",
      flowmeterList_aggregate: [],
      isEletricitymeterFold_aggregate: false,
      isEletricitymeterFoldMessage_aggregate: "",
      electricityMeterList_aggregate: [],
      isAggregateLoading: false,
      deviceTypeOptions: [],
      points: {
        all: [],
        LLJ: [],
        DB: []
      },
      pointsOptions: [],
      selectedDeviceType: undefined,
      selectedPoint: undefined,
      isAggregateAnalysing: false
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(_, o) {
        this.translate(o)
      }
    }
  },
  created() {
    const now = new Date()
    this.dayTimeValue = now
    let month_end = new Date()
    let month_start = new Date()
    month_start.setMonth(month_end.getMonth() - 1)
    this.monthTimeValue = [month_start, month_end]
    let year_end = new Date()
    let year_start = new Date()
    year_start.setFullYear(year_end.getFullYear() - 1)
    this.yearTimeValue = [year_start, year_end]
    const authorities = this.getAuthorities("/equipment/group")
    let a
    for (let i = 0; i < authorities.length; i++) {
      a = authorities[i].code
      if (a === "device:manage:device:group:stats:export") {
        this.isExportable = true
      }
    }
    this.dayRemarkList = {
      en: [
        {
          label: "",
          content: "The following uses 08:00:00 on October 10 as an example"
        },
        {
          label: "Daily: ",
          content: "Distinguish by hour, 08:00:00 indicates the usage between 7:00 and 8:00"
        },
        {
          label: "Average Gas Consumption: ",
          content: "(Meter accumulation at 8 points - meter accumulation at 7 points)/60 minutes"
        },
        {
          label: "Flow Meter Accumulation: ",
          content: "Flow meter accumulation at 8 o'clock"
        },
        {
          label: "Power per hour: ",
          content: "(Electricity meter accumulation at 8 o'clock - electricity meter accumulation at 7 o'clock) / 1 hour"
        },
        {
          label: "Electricity Meter Accumulation: ",
          content: "Electricity meter accumulation at 8 o'clock"
        },
        {
          label: "Average Pressure: ",
          content: "Pressure values read at 8 o'clock Total / points number"
        },
        {
          label: "Average Consumption: ",
          content: "(Electricity meter accumulation at 8 o 'clock - electricity meter accumulation at 7 o 'clock) / (flow meter accumulation at 8 o 'clock - flow meter accumulation at 7 o 'clock)"
        },
        {
          label: "Cumulative total for the day: ",
          content: "Electricity or gas accumulation at 24:00 on October 10 - Electricity or gas accumulation at 24:00 on October 9"
        }
      ],
      zh: [
        {
          label: "",
          content: "以下用10月10日08:00:00为例"
        },
        {
          label: "按日：",
          content: "以小时为单位，08:00:00为7点-8点的用量"
        },
        {
          label: "平均用气量：",
          content: "(8点的流量计累积-7点的流量计累积)/60分钟"
        },
        {
          label: "流量计累积：",
          content: "8点时的流量计累积量"
        },
        {
          label: "小时用电量：",
          content: "(8点的电表累积-7点的电表累积)/1小时"
        },
        {
          label: "电表累积：",
          content: "8点时的电表累积量"
        },
        {
          label: "平均压力：",
          content: "7点-8点间读取到的压力值合计/读取到的点数"
        },
        {
          label: "平均单耗：",
          content: "(8点的电表累积-7点的电表累积)/(8点的流量计累积-7点的流量计累积)"
        },
        {
          label: "本日累积合计值：",
          content: "10月10日24:00:00的电量或气量累计-10月9日24:00:00的电量或气量累计"
        }
      ]
    }
    this.monthRemarkList = {
      en: [
        {
          label: "",
          content: "Take October 10 as an example"
        },
        {
          label: "Monthly: ",
          content: "Distinguish by day"
        },
        {
          label: "Average Gas Consumption: ",
          content: "(Flow meter accumulation on October 10 - Flow meter accumulation on October 9) / 24 hours / 60 minutes"
        },
        {
          label: "Flow Meter Accumulation: ",
          content: "Flow meter accumulation at 24 o 'clock on October 10"
        },
        {
          label: "Power per hour: ",
          content: "(Electricity meter accumulation on October 10 - electricity meter accumulation on October 9) / 24 hours"
        },
        {
          label: "Electricity Meter Accumulation: ",
          content: "Electricity meter accumulation at 24 o 'clock on October 10"
        },
        {
          label: "Average Pressure: ",
          content: "Pressure values read on October 10 Total / points number"
        },
        {
          label: "Average Consumption: ",
          content: "(Electricity meter accumulation at 24 o 'clock on October 10 - meter accumulation at 24 points on October 9) / (flow meter accumulation at 24 points on October 10 - flow meter accumulation at 24 o 'clock on October 9)"
        },
        {
          label: "Cumulative total for the month: ",
          content: "Electricity or gas accumulation at 24:00 on October 31 - Electricity or gas accumulation at 24:00 on September 30"
        }
      ],
      zh: [
        {
          label: "",
          content: "以下用10月10日为例"
        },
        {
          label: "按月：",
          content: "以天为单位"
        },
        {
          label: "平均用气量：",
          content: "(10月10日的流量计累积-10月9日的流量计累积)/24小时/60分钟"
        },
        {
          label: "流量计累积：",
          content: "10月10日24点时的流量计累积量"
        },
        {
          label: "小时用电量：",
          content: "(10月10日的电表累积-10月9日的电表累积)/24小时"
        },
        {
          label: "电表累积：",
          content: "10月10日24点时的电表累积量"
        },
        {
          label: "平均压力：",
          content: "10月10日读取到的压力值合计/读取到的点数"
        },
        {
          label: "平均单耗：",
          content: "(10月10日24点的电表累积-10月9日24点的电表累积)/(10月10日24点的流量计累积-10月9日24点的流量计累积)"
        },
        {
          label: "本月累积合计值：",
          content: "10月31日24:00:00的电量或气量累计-9月30日24:00:00的电量或气量累计"
        }
      ]
    }
    this.yearRemarkList = {
      en: [
        {
          label: "",
          content: "Take October 2024 as an example"
        },
        {
          label: "Yearly: ",
          content: "Distinguish by month"
        },
        {
          label: "Average Gas Consumption: ",
          content: "(Flow meter accumulation on October 31 - Flow meter accumulation on September 30) / 31 days / 24 hours / 60 minutes"
        },
        {
          label: "Flow Meter Accumulation: ",
          content: "Flow meter accumulation at 24 o 'clock on October 31"
        },
        {
          label: "Power per hour: ",
          content: "(Electricity meter accumulation on October 31 - electricity meter accumulation on September 30) / 31 days /  24 hours"
        },
        {
          label: "Electricity Meter Accumulation: ",
          content: "Electricity meter accumulation at 24 o 'clock on October 31"
        },
        {
          label: "Average Pressure: ",
          content: "Pressure values read on October Total / points number"
        },
        {
          label: "Average Consumption: ",
          content: "(Electricity meter accumulation at 24 o 'clock on October 31 - meter accumulation at 24 points on September 30) / (flow meter accumulation at 24 points on October 31 - flow meter accumulation at 24 o 'clock on September 30)"
        },
        {
          label: "Cumulative total for the month: ",
          content: "Electricity or gas accumulation at 24:00 on December 31, 2025 - Electricity or gas accumulation at 24:00 on December 31, 2024"
        }
      ],
      zh: [
        {
          label: "",
          content: "以下用2024年10月为例"
        },
        {
          label: "按年：",
          content: "以月为单位"
        },
        {
          label: "平均用气量：",
          content: "(10月31日的流量计累积-9月30日的流量计累积)/31天/24小时/60分钟"
        },
        {
          label: "流量计累积：",
          content: "10月31日24点时的流量计累积量"
        },
        {
          label: "小时用电量：",
          content: "(10月31日的电表累积-9月30日的电表累积)/31天/24小时"
        },
        {
          label: "电表累积：",
          content: "10月31日24点时的电表累积量"
        },
        {
          label: "平均压力：",
          content: "10月读取到的压力值合计/读取到的点数"
        },
        {
          label: "平均单耗：",
          content: "(10月31日24点的电表累积-9月30日24点的电表累积)/(10月31日24点的流量计累积-9月30日24点的流量计累积)"
        },
        {
          label: "本年累积合计值：",
          content: "2024年12月31日24:00:00的电量或气量累计-2023年12月31日24:00:00的电量或气量累计"
        }
      ]
    }
    this.remarkList = this.dayRemarkList
    this.chartsGroup = {}
  },
  mounted() {
    this.isLoading = true
    this.render()

    /* 
      测试画饼图
    */
    // setTimeout(this.renderPieChart, 3000)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.bindResizeListener)
    document.removeEventListener("mouseup", this.unbindMove)
  },
  methods: {
    translate(o) {
      locale.use(this[this.lang])
      this.isFlowmeterFoldMessage_aggregate = this.isEletricitymeterFoldMessage_aggregate = this.isFlowmeterFoldMessage = this.isEletricitymeterFoldMessage = this.$t("buttons.fold")
      this.templateRules = {
        name: [
          {
            required: true,
            message: this.$t("placeholder.templateName"),
            trigger: "blur"
          }
        ]
      }
      this.pickerOptions = {
        shortcuts: [
          {
            text: this.$t("station.tld"),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: this.$t("station.tlw"),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            }
          },
          {
            text: this.$t("station.tlm"),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31)
              picker.$emit("pick", [start, end])
            }
          }
        ]
      }
      for (let key in this.exportColumns) {
        this.exportColumns[key] = this.$t(`dataReport.${key}`)
      }
      this.deviceTypeOptions = [
        {
          key: "LLJ",
          name: this.$t("station.LLJ")
        },
        {
          key: "DB",
          name: this.$t("station.DB")
        }
      ]
      if (o) {
        this.renderCharts(this.x, this.y, this.activeCategory !== "day")
      }
    },
    async render() {
      const stationInfo = await this.requestStationInfo()
      if (stationInfo) {
        this.stationName = stationInfo.name
        this.isFlowmeterShow = !stationInfo.elecVisible
        this.exportForm.unit = stationInfo.extraProperty.unit || "Nm³"
        this.setDevices(stationInfo.devices)
        this.setStationInfo(stationInfo)
        this.setColumns()
        
        if (this.flowmeterList.length + this.electricityMeterList.length === 0) {
          this.isLoading = false
          return this.$message.error(this.$t("dataReport.noDevice"))
        }
        this.$nextTick(this.initCharts)
        this.selectModel(0)
      }
    },
    setColumns() {
      if (this.isFlowmeterShow) {
        this.columns = setCompleteColumns(this.exportForm.unit)
        this.pointsOfCharts = setCompletePointsOfCharts(this.exportForm.unit)
      } else {
        this.columns = onlyDBColumns
        this.pointsOfCharts = onlyDBPointsOfCharts
      }
    },
    setStationInfo(r) {
      this.stationForm = r
      const t = r.extraProperty.templateSetting
      this.setModels(t)
    },
    selectModel(i) {
      this.isLoading = true
      this.activeModelIndex = i
      let p
      for (let j = 0; j < this.pointsOfCharts.length; j++) {
        p = this.pointsOfCharts[j]
        p.min = Infinity
        p.max = -Infinity
      }
      this.setDeviceSelectedState(this.activeModelIndex, this.flowmeterList, this.electricityMeterList)
      this.renderTableAndChart()
    },
    selectModel_aggregate(i) {
      this.activeModelIndex_aggregate = i
      this.setDeviceSelectedState(this.activeModelIndex_aggregate, this.flowmeterList_aggregate, this.electricityMeterList_aggregate)
    },
    showTemplateModal(type) {
      this.templateModalTitle = this.$t(`dataReport.${type}Template`)
      this.templateModalState = type
      this.templateModalVisible = true
      if (type === "edit") {
        this.templateForm = { ...this.models[this.activeModelIndex] }
      }
    },
    submitTemplate() {
      this.$refs.templateForm.validate(async valid => {
        if (valid) {
          this.templateModalLoading = true
          const form = { ...this.templateForm }
          form.id = nanoid()
          if (form.startTime?._d) {
            form.startTime = +new Date(form.startTime._d)
          }
          let models = [...this.models]
          if (models[0].id === "all") {
            models = models.slice(1)
          }
          if (this.templateModalState === "add") {
            models.push(form)
          } else {
            models[this.activeModelIndex - 1] = form
          }

          this.stationForm.extraProperty.templateSetting = JSON.stringify(models)
          try {
            const { message } = await updateDeviceGroup(this.stationForm)
            this.$message.success(message)
            this.templateModalVisible = false
            this.isLoading = true
            const stationInfo = await this.requestStationInfo()
            this.setStationInfo(stationInfo)
            if (this.templateModalState === "add") {
              this.isLoading = false
            } else {
              this.selectModel(this.activeModelIndex)
            }
          } catch(e) {
            console.log(e)
          } finally {
            this.templateModalLoading = false
          }
        }
      })
    },
    clearTemplateForm() {
      this.$refs.templateForm.resetFields()
      this.templateForm = {
        sort: 1,
        name: "",
        flowmeter: [],
        elctricitymeter: [],
        gasElectricRatio: undefined,
        pressureDeviceCode: "",
        pressureParamCode: "",
        startTime: ""
      }
    },
    async getPoints() {
      const device = this.deviceList.find(d => d.code === this.templateForm.pressureDeviceCode)
      if (device) {
        const { data: { points } } = await getProtocol(device.protocolCode)
        this.pressurePoints = points.filter(p => p.read !== false && p.dataWrite !== 2)
      }
    },
    confirmToDeleteModel() {
      this.$confirm({
        title: this.$t("dataReport.confirmToDeleteModel"),
        content: this.$t("dataReport.clickToConfirmDelete"),
        onOk: async () => {
          try {
            let models = [...this.models]
            if (models[0].id === "all") {
              models = models.slice(1)
            }
            models.splice(this.activeModelIndex - 1, 1)
            this.stationForm.extraProperty.templateSetting = JSON.stringify(models)
            const { message } = await updateDeviceGroup(this.stationForm)
            this.$message.success(message)
            this.isLoading = true
            const stationInfo = await this.requestStationInfo()
            this.setStationInfo(stationInfo)
            this.selectModel(0)
          } catch(e) {
            console.log(e)
          }
        }
      })
    },
    changeNavFold(field) {
      this[`is${field}`] = !this[`is${field}`]
      this[`is${field}Message`] = this[`is${field}`] ? this.$t("buttons.expand") : this.$t("buttons.fold")
    },
    changeNavFold_aggregate(field) {
      this[`is${field}_aggregate`] = !this[`is${field}_aggregate`]
      this[`is${field}Message_aggregate`] = this[`is${field}_aggregate`] ? this.$t("buttons.expand") : this.$t("buttons.fold")
    },
    toggleCategory(c) {
      this.activeCategory = c.key
      this.isLoading = true
      this.renderTableAndChart()
    },
    async renderTableAndChart() {
      this.isLoading = true
      this.clearMinAndMax()
      let res, r, x = [], y = {}, p, v
      switch(this.activeCategory) {
        case "day":
          if (!this.dayTimeValue) {
            this.isLoading = false
            return this.$message.warning(this.$t("device.selectRange"))
          }
          res = await this.requestDayReport()
          break
        case "month":
          if (!this.monthTimeValue) {
            this.isLoading = false
            return this.$message.warning(this.$t("device.selectRange"))
          }
          const gap = (this.monthTimeValue[1] - this.monthTimeValue[0]) / 1000 / 60 / 60 / 24
          if (gap > 31) {
            this.isLoading = false
            return this.$message.warning(this.$t("messages.moreThanOneMonth"))
          }
          res = await this.requestMonthReport()
          break
        case "year":
          if (!this.yearTimeValue) {
            this.isLoading = false
            return this.$message.warning(this.$t("device.selectRange"))
          }
          res = await this.requestYearReport()
          break
        default:
          res = []
          this.isLoading = false
          break
      }
      this.tableData = res

      if (res.length) {
        for (let i = 0; i < res.length - 1; i++) {
          r = res[i]
          x.push(this.activeCategory === "day" ? r.datetime.slice(11, 16) : r.datetime)
          for (let j = 0; j < this.pointsOfCharts.length; j++) {
            p = this.pointsOfCharts[j]
            v = +r[p.key]
            if (v > 0) {
              p.min = Math.min(p.min, v)
              p.max = Math.max(p.max, v)
            }
            if (y[p.key]) {
              y[p.key].push(v.toFixed(p.key === "avgConsumption" ? 5 : 2))
            } else {
              y[p.key] = [v.toFixed(p.key === "avgConsumption" ? 5 : 2)]
            }
          }
        }
  
        for (let i = 0; i < this.pointsOfCharts.length; i++) {
          p = this.pointsOfCharts[i]
          if (p.min === Infinity) {
            p.min = 0
          }
          if (p.max === -Infinity) {
            p.max = 0
          }
          p.min = p.min.toFixed(p.key === "avgConsumption" ? 5 : 2)
          p.max = p.max.toFixed(p.key === "avgConsumption" ? 5 : 2)
        }
        this.renderCharts(x, y, this.activeCategory !== "day")
      } else {
        for (let i = 0; i < this.pointsOfCharts.length; i++) {
          p = this.pointsOfCharts[i]
          p.min = 0
          p.max = 0
          p.min = p.min.toFixed(p.key === "avgConsumption" ? 5 : 2)
          p.max = p.max.toFixed(p.key === "avgConsumption" ? 5 : 2)
          y[p.key] = []
        }
        this.renderCharts(x, y, this.activeCategory !== "day")
      }
      this.x = x
      this.y = y
      this.isLoading = false
    },
    async requestDayReport() {
      const date = moment(+this.dayTimeValue).format("YYYY-MM-DD")
      try {
        const deviceCode = this.deviceList.filter(d => d.selected).map(d => d.code)
        const { data } = await getDayReport(date, deviceCode + "", this.flowPowerEnabled)
        return data
      } catch(e) {
        console.log(e)
        return []
      }
    },
    async requestMonthReport() {
      const start = moment(+this.monthTimeValue[0]).format("YYYY-MM-DD")
      const end = moment(+this.monthTimeValue[1]).format("YYYY-MM-DD")
      try {
        const deviceCode = this.deviceList.filter(d => d.selected).map(d => d.code)
        const { data } = await getMonthReport(start, end, deviceCode + "", this.flowPowerEnabled)
        return data
      } catch(e) {
        console.log(e)
        return []
      }
    },
    async requestYearReport() {
      const start = moment(+this.yearTimeValue[0]).format("YYYY-MM-DD")
      const end = moment(+this.yearTimeValue[1]).format("YYYY-MM-DD")
      try {
        const deviceCode = this.deviceList.filter(d => d.selected).map(d => d.code)
        const { data } = await getYearReport(start, end, deviceCode + "", this.flowPowerEnabled)
        return data
      } catch(e) {
        console.log(e)
        return []
      }
    },
    clearMinAndMax() {
      let p
      for (let i = 0; i < this.pointsOfCharts.length; i++) {
        p = this.pointsOfCharts[i]
        p.min = Infinity
        p.max = -Infinity
      }
    },
    showExportParamsModal() {
      this.exportParamsModalVisible = true
      switch(this.activeCategory) {
        case "day":
          if (this.dayTimeValue) {
            this.exportForm.startDate = moment(+this.dayTimeValue)
            this.exportForm.endDate = moment(+this.dayTimeValue)
          } else {
            this.exportForm.startDate = moment(+new Date())
            this.exportForm.endDate = moment(+new Date())
          }
          break
        case "month":
          if (this.monthTimeValue) {
            this.exportForm.startDate = moment(+this.monthTimeValue[0])
            this.exportForm.endDate = moment(+this.monthTimeValue[1])
          } else {
            let s = new Date()
            s.setMonth(s.getMonth() - 1)
            this.exportForm.startDate = moment(+s)
            this.exportForm.endDate = moment(+new Date())
          }
          break
        case "year":
          if (this.yearTimeValue) {
            this.exportForm.startDate = moment(+this.yearTimeValue[0])
            this.exportForm.endDate = moment(+this.yearTimeValue[1])
          } else {
            let s = new Date()
            s.setFullYear(s.getFullYear() - 1)
            this.exportForm.startDate = moment(+s)
            this.exportForm.endDate = moment(+new Date())
          }
          break
      }
    },
    async exportToExcel() {
      this.isExporting = true
      if (!this.exportForm.startDate || !this.exportForm.endDate) {
        return this.$message.warning(this.$t("dataReport.selectTimeRange"))
      }

      const params = {
        startDate: this.exportForm.startDate.format("YYYY-MM-DD"),
        endDate: this.exportForm.endDate.format("YYYY-MM-DD"),
        deviceCode: this.deviceList.filter(d => d.selected).map(d => d.code) + "",
        columns: this.exportForm.columns + "",
        unit: this.exportForm.unit
      }
      try {
        let res
        switch(this.activeCategory) {
          case "day":
            res = await exportReport(params)
            break
          case "month":
            res = await exportReportM(params)
            break
          case "year":
            res = await exportReportY(params)
            break
        }

        const { data } = res
        const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
        const link = document.createElement("a")
        link.style.display = "none"
        link.href = url
        const name = `${params.startDate}-${params.endDate} ${this.stationName} 数据报表`
        link.download = name + ".xlsx"
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
        this.$message.success("导出成功", 1)
        this.exportParamsModalVisible = false
      } catch(e) {
        console.log(e)
      } finally {
        this.isExporting = false
      }
    },
    toggleChartType(t) {
      this.activeChartType = t
      this.renderCharts(this.x, this.y, this.activeCategory !== "day")
    },
    initCharts() {
      let p
      for (let i = 0; i < this.pointsOfCharts.length; i++) {
        p = this.pointsOfCharts[i]
        this.chartsGroup[p.key] = this.$echarts.init(document.getElementById(p.key))
      }
    },
    renderCharts(x, y, rotate) {
      let p, option
      for (let i = 0; i < this.pointsOfCharts.length; i++) {
        p = this.pointsOfCharts[i]
        option = {
          grid: {
            top: "23%",
            left: "10%",
            right: "12%",
            bottom: rotate ? "22%" : "11%"
          },
          tooltip: {
            trigger: "axis"
          },
          xAxis: {
            type: "category",
            data: x,
            boundaryGap: true,
            axisLabel: {
              show: true,
              interval: 0,
              rotate: rotate ? 40 : 0,
              color: "#fff"
            },
            axisTick: {
              show: true,
              lineStyle: {
                color: "#666"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#666"
              }
            }
          },
          yAxis: {
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                color: "#666"
              }
            },
            axisLabel: {
              color: "#fff"
            }
          },
          series: [
            {
              name: p.description[this.lang],
              type: this.activeChartType,
              lineStyle: {
                width: 3,
                color: colors[i]
              },
              itemStyle: {
                color: colors[i]
              },
              label: {
                show: true,
                color: "#fff",
                rotate: rotate ? 50 : 0,
                position: "top"
              },
              smooth: false,
              symbolSize: 0,
              data: y[p.key]
            }
          ]
        }
        this.chartsGroup[p.key].setOption(option, {
          replaceMerge: [
            "xAxis",
            "yAxis",
            "series",
            "tooltip"
          ]
        })
      }
    },
    bindResizeListener() {
      for (let key in this.chartsGroup) {
        this.chartsGroup[key].resize()
      }
    },
    async requestStationInfo() {
      try {
        const { data } = await getDeviceGroup(this.$route.query.id)
        return data
      } catch(e) {
        console.log(e)
        return null
      }
    },
    setDevices(devices) {
      let d
      const f = [], e = [], res = []
      for (let i = 0; i < devices.length; i++) {
        d = devices[i]
        if (d.type === "LLJ") {
          f.push(d)
          res.push(d)
        }
        if (d.type === "DB") {
          e.push(d)
          res.push(d)
        }
      }
      this.flowmeterList = f
      this.electricityMeterList = e
      this.deviceList = res
    },
    setModels(t) {
      let models = []
      if (t) {
        try {
          models = JSON.parse(t)
        } catch(e) {
          console.log(e)
          models = []
        }
      }
      if (!models.find(m => m.id === "all")) {
        models.unshift({
          id: "all",
          name: "全部",
          sort: 0,
          flowmeter: this.flowmeterList.map(f => f.code),
          elctricitymeter: this.electricityMeterList.map(e => e.code)
        })
      }
      models.sort((a, b) => a.sort - b.sort)
      this.models = models
    },
    setDeviceSelectedState(mi, fl, el) {
      const m = this.models[mi]
      let f, e
      for (let i = 0; i < fl.length; i++) {
        f = fl[i]
        f.selected = !!m.flowmeter.find(flow => flow === f.code)
      }
      for (let i = 0; i < el.length; i++) {
        e = el[i]
        e.selected = !!m.elctricitymeter.find(ele => ele === e.code)
      }
    },
    handleFlowPowerEnableChange() {
      this.isLoading = true
      
      this.columns[2].visible = this.flowPowerEnabled
      this.columns[3].visible = this.flowPowerEnabled
      if (this.isFlowmeterShow) {
        this.columns[6].visible = this.flowPowerEnabled
        this.columns[7].visible = this.flowPowerEnabled
      }
      this.renderTableAndChart()
    },
    startDrag(e) {
      const { aggregate } = this.$refs
      const x = e.pageX - aggregate.offsetLeft
      const y = e.pageY - aggregate.offsetTop

      function move(e) {
        aggregate.style.left = e.pageX - x + "px"
        aggregate.style.top = e.pageY - y + "px"
      }
      document.addEventListener("mousemove", move)

      function unbindMove() {
        document.removeEventListener("mousemove", move)
      }
      document.addEventListener("mouseup", unbindMove)

      this.unbindMove = unbindMove
    },
    renderPieChart(r) {
      if (!this.pieChart) {
        this.pieChart = this.$echarts.init(document.getElementById("pie"))
      }
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: [0, '70%'],
            label: {
              fontSize: 16,
              formatter: "{b}: {d}%",
              show: true,
              color: "inherit"
            },
            labelLine: {
              show: true
            },
            data: r.map(d => ({
              name: d.name,
              value: d.value
            }))
          }
        ]
      }

      this.pieChart.setOption(option)
    },
    clearAggregate() {
      this.isAggregateVisible = false
      this.aggregateTimeValue = null
      this.selectedDeviceType = undefined
      this.selectedPoint = undefined
      this.ranges_aggregate = []
      this.pieChart?.clear()
      this.originChart?.clear()
    },
    showAggregate() {
      this.isAggregateVisible = true
      this.activeModelIndex_aggregate = this.activeModelIndex
      this.flowmeterList_aggregate = this.flowmeterList.map(f => ({ ...f }))
      this.electricityMeterList_aggregate = this.electricityMeterList.map(e => ({ ...e }))
      let time
      switch(this.activeCategory) {
        case "day":
          if (this.dayTimeValue) {
            time = new Date(this.dayTimeValue)
          } else {
            time = new Date()
          }
          const t = []
          time.setHours(0, 0, 0, 0)
          t.push(new Date(time))
          time.setHours(23, 59, 59, 999)
          t.push(new Date(time))
          this.aggregateTimeValue = t
          break
        case "month":
          if (this.monthTimeValue) {
            this.aggregateTimeValue = [new Date(this.monthTimeValue[0].setHours(0, 0, 0, 0)), new Date(this.monthTimeValue[1].setHours(23, 59, 59, 999))]
          } else {
            time = new Date()
            const end = new Date(time.setHours(23, 59, 59, 999))
            let start = new Date(time.setMonth(time.getMonth() - 1))
            start.setHours(0, 0, 0, 0)
            this.aggregateTimeValue = [start, end]
          }
          break
        case "year":
          if (this.yearTimeValue) {
            this.aggregateTimeValue = [new Date(this.yearTimeValue[0].setHours(0, 0, 0, 0)), new Date(this.yearTimeValue[1].setHours(23, 59, 59, 999))]
          } else {
            time = new Date()
            const end = new Date(time.setHours(23, 59, 59, 999))
            let start = new Date(time.setFullYear(time.getFullYear() - 1))
            start.setHours(0, 0, 0, 0)
            this.aggregateTimeValue = [start, end]
          }
          break
        default:
          break
      }

      this.setAggregateDevicePoints()
    },
    async setAggregateDevicePoints() {
      this.isAggregateLoading = true
      try {
        const fPointsMap = {}, ePointsMap = {}, fPoints = [], ePoints = []
        let p
        for await (let f of this.flowmeterList_aggregate) {
          if (f.selected) {
            const { data: { points } } = await getProtocol(f.protocolCode)
            for (let i = 0; i < points.length; i++) {
              p = points[i]
              if (p.read !== false && p.dataWrite !== 2) {
                if (fPointsMap[p.code]) {
                  fPointsMap[p.code].count++
                } else {
                  fPointsMap[p.code] = {
                    count: 1,
                    value: p
                  }
                }
              }
            }
          }
        }
        for await (let e of this.electricityMeterList_aggregate) {
          if (e.selected) {
            const { data: { points } } = await getProtocol(e.protocolCode)
            for (let i = 0; i < points.length; i++) {
              p = points[i]
              if (p.read !== false && p.dataWrite !== 2) {
                if (ePointsMap[p.code]) {
                  ePointsMap[p.code].count++
                } else {
                  ePointsMap[p.code] = {
                    count: 1,
                    value: p
                  }
                }
              }
            }
          }
        }
        for (let k in fPointsMap) {
          if (fPointsMap[k].count === this.flowmeterList_aggregate.length) {
            fPoints.push(fPointsMap[k].value)
          }
        }
        for (let k in ePointsMap) {
          if (ePointsMap[k].count === this.electricityMeterList_aggregate.length) {
            ePoints.push(ePointsMap[k].value)
          }
        }
        this.points.LLJ = fPoints
        this.points.DB = ePoints
      } catch(e) {
        console.log(e)
      } finally {
        this.isAggregateLoading = false
      }
    },
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode
    },
    handleDeviceTypeChange() {
      this.pointsOptions = this.points[this.selectedDeviceType]
      this.selectedPoint = undefined
    },
    addRange_aggregate() {
      this.ranges_aggregate.push({
        id: nanoid(),
        min: undefined,
        max: undefined
      })
    },
    async analyse_aggregate() {
      if (!(this.selectedDeviceType && this.selectedPoint)) {
        return this.$message.warning(this.$t("device.selectPoints"))
      }
      this.isAggregateAnalysing = true
      const ranges = []
      let r
      for (let i = 0; i < this.ranges_aggregate.length; i++) {
        r = this.ranges_aggregate[i]
        if (!isNaN(r.min) && !isNaN(r.max)) {
          ranges.push({
            min: +r.min,
            max: +r.max,
            value: 0,
            name: r.min + " ~ " + r.max
          })
        }
      }
      let deviceId = ""
      if (this.selectedDeviceType === "LLJ") {
        deviceId = this.flowmeterList_aggregate.filter(f => f.selected).map(f => f.id) + ""
      }
      if (this.selectedDeviceType === "DB") {
        deviceId = this.electricityMeterList_aggregate.filter(f => f.selected).map(f => f.id) + ""
      }
      try {
        let startTime = +new Date(this.aggregateTimeValue[0])
        let endTime = +new Date(this.aggregateTimeValue[1])
        const { data } = await getAggregateHistoryData({
          deviceId,
          pointCode: this.selectedPoint,
          startTime,
          endTime
        })
        let d
        for (let i = 0; i < data.length; i++) {
          d = data[i][this.selectedPoint]
          for (let j = 0; j < ranges.length; j++) {
            r = ranges[j]
            if (d >= r.min && d < r.max) {
              r.value++
            }
          }
        }
        let count = data.length
        for (let i = 0; i < ranges.length; i++) {
          count -= ranges[i].value
        }
        if(count > 0) {
          ranges.push({
            name: "其它",
            value: count
          })
        }
        this.renderPieChart(ranges)
        const point = this.pointsOptions.find(p => p.code === this.selectedPoint)
        let pointName = ""
        if (point) {
          pointName = point.name
        }
        this.renderOriginChart(data.map(d => [+new Date(d.time), d[this.selectedPoint]]), pointName)
      } catch(e) {
        console.log(e)
      } finally {
        this.isAggregateAnalysing = false
      }
    },
    renderOriginChart(data, name) {
      if (!this.originChart) {
        this.originChart = this.$echarts.init(document.getElementById("origin"))
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%'];
          }
        },
        grid: {
          top: "5%",
          bottom: "27%",
          left: "8%",
          right: "3%"
        },
        xAxis: {
          type: 'time',
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%']
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 20
          },
          {
            start: 0,
            end: 20
          }
        ],
        series: [
          {
            name,
            type: 'line',
            smooth: true,
            symbol: 'none',
            areaStyle: {},
            data
          }
        ]
      }
      this.originChart.setOption(option)
    },
    deleteLastRange() {
      this.ranges_aggregate.pop()
    }
  }
}
</script>

<style lang="less" scoped>
div, ul, li, p, label, hr, h2 {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

li {
  list-style: none;
}

.dataStatistics {
  position: relative;
  background-color: #2f3d4f;
  min-height: 860px;

  .title {
    padding: 10px 10px 0;
    display: flex;
    align-items: center;

    .stationName {
      color: #fff;
      font-size: 24px;
    }

    .buttons_group {
      // margin-left: auto;
      margin-right: 10px;

      /deep/ .ant-btn {
        margin-left: 15px;
      }
    }
  }

  .headerNav {
    width: 100%;
    display: flex;
    justify-content: space-between;

    li {
      width: 50%;
      background-color: #212d3f;
      margin: 18px;
      padding: 10px;
    }

    .fold {
      height: 50%;
    }

    header {
      h3 {
        float: left;
        color: #f8fced;
        margin-bottom: 10px;
      }

      span {
        color: #2d8cfa;
        float: right;
        cursor: pointer;
      }

      .anticon-double-right, .anticon-double-left {
        transform: rotateZ(90deg);
      }

      .border {
        clear: both;
        border-bottom: 1px solid #1976cf;
      }
    }

    .nav_body {
      ul {
        overflow: hidden;

        li {
          float: left;
          margin: 10px 0 10px 10px;
          width: 150px;
          height: 25px;
          font-size: 16px;
          background-color: #4a90e2;
          color: #f8fced;
          text-align: center;

          label {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
          }

          .device_name {
            color: #fff;
            float: left;
            width: 120px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          input[type^="checkbox"] {
            width: 15px;
            height: 15px;
            vertical-align: middle;
          }
        }
      }
    }
  }

  .content {
    margin: 0 18px;

    .search {
      position: relative;

      span {
        display: inline-block;
        width: 100px;
        height: 30px;
        border: 1px solid #4e5a69;
        color: #cbcfc7;
        text-align: center;
        line-height: 30px;
        cursor: pointer;

        &.active {
          background-color: #2199e9;
          color: #f8fced;
        }

        &:nth-child(2) {
          border-left: none;
          border-right: none;
        }
      }

      .buttons {
        display: inline-block;
        margin-left: 5px;
        transform: translateY(-1px);

        .ant-btn {
          margin-left: 10px;
        }
      }

      .right_buttons {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
      }
    }

    .table_wrapper {
      margin-top: 16px;

      table {
        width: 100%;
        border-top: 1px solid #4a5665;
        border-left: 1px solid #4a5665;
        color: #a7adb5;
  
        th, td {
          height: 40px;
          padding-left: 15px;
          border-bottom: 1px solid #5b6574;
          border-right: 1px solid #5b6574;
        }

        th {
          background-color: #485464;
        }
      }
    }

    .charts_group_wrapper {
      position: relative;
      margin-top: 16px;

      .type_toggler {
        position: absolute;
        right: 0;
        top: 0;
        display: flex;

        li {
          color: #a5abb3;
          margin-left: 10px;
          font-size: 18px;
          cursor: pointer;

          &.active {
            color: #2199e9;
          }
        }
      }

      .charts_group {
        h3 {
          color: #a5abb3;
          font-size: 20px;
          margin-top: 20px;
        }

        .range_btn {
          padding: 5px 8px;
          border: 1px solid #ccc;
          border-top: none;
          background-color: #2f3d4f;
          color: #ccc;
          cursor: pointer;
        }

        .chart_wrapper {
          position: relative;

          .chart {
            width: 100%;
            height: 240px;
          }

          .tooltip {
            position: absolute;
            right: 1%;
            top: 20%;

            p {
              color: #fff;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}

.remarkUl {
  li {
    margin-bottom: 15px;
    font-size: 15px;

    i {
      font-style: normal;
      font-weight: 600;
    }
  }
}

/deep/ .el-loading-mask {
  background-color: rgba(0, 0, 0, .2);

  .el-loading-spinner {
    top: 18%;
  }
}

/deep/ .ant-checkbox-wrapper {
  margin-bottom: 0 !important;
}

/deep/ .el-date-editor {
  transform: translateY(-1px);
  margin-left: 15px;

  .el-input__icon {
    margin-top: -4px;
  }
}

/deep/ .el-range-editor {
  border: 1px solid #4E5A69;

  .el-icon-date::before {
    top: -1px;
  }

  .el-range-separator {
    line-height: 24px;
  }

  input {
    color: #CBCFC7;
  }

  .el-range__close-icon {
    margin-top: 0;
  }
}

/deep/ .el-input--prefix .el-input__inner {
  outline: none;
  background-color: #2F3D4F;
  height: 32px;
  color: #CBCFC7;
  border: 1px solid #4E5A69;
}

.models {
  display: flex;
  margin-left: 18px;
  flex: 1;

  li {
    color: #a5abb3;
    font-size: 18px;
    margin-left: 10px;
    cursor: pointer;

    &.active {
      color: #2199e9;
    }
  }
}

.mask {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  width: 1380px;
  height: 860px;
  background-color: #2F3D4F;
  border: 1px solid #ccc;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  cursor: move;
  padding: 30px;
  z-index: 10;

  .wrapper {
    cursor: default;
  }

  i.anticon-close {
    font-size: 30px;
    position: absolute;
    top: 10px;
    right: 10px;
    color: #fff;
    cursor: pointer;
  }

  h2 {
    color: #fff;
  }

  .header {
    display: flex;
    align-items: center;
  }

  .search {
    display: flex;
    align-items: center;

    /deep/ .el-date-editor {
      transform: translateY(0px);
      margin-left: 0;
    }

    label {
      color: #fff;
    }

    /deep/ .ant-select-selection {
      background-color: #2F3D4F;
    }

    /deep/ .ant-select-selection-selected-value {
      color: #fff;
    }

    /deep/ .el-icon-time {
      position: relative;
      margin-left: 0;
      margin-top: 0;
      top: 0;
    }
  }

  .ranges {
    color: #fff;
    display: flex;
    flex-wrap: wrap;

    li {
      margin: 0 0 8px 10px;
      display: flex;
      align-items: center;
    }

    /deep/ .ant-input {
      background-color: #2F3D4F;
      color: #fff;
    }
  }

  .content {
    width: 100%;
    height: 530px;
    border: 1px solid #ccc;
    margin: 0;
    display: flex;
    margin-top: 22px;
    box-sizing: border-box;

    h3 {
      color: #fff;
      margin-left: 1em;
      margin-top: .2em;
    }
  }
  .left {
    width: 50%;
    border-right: 1px solid #ccc;
    height: 100%;

    .top {
      height: 40%;
      border-bottom: 1px solid #ccc;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 8px;
        border-radius: 4px;
      }
      &::-webkit-scrollbar-track {
        width: 8px;
        border-radius: 4px;
      }
      &::-webkit-scrollbar-thumb {
        width: 8px;
        background-color: #4961a3;
        border-radius: 4px;
      }
    }
    .bottom {
      height: 60%;
    }
  }

  .right {
    width: 50%;
  }

  .chart {
    width: 100%;
    height: 85%;
  }
}

.mask::-webkit-scrollbar {
  width: 8px;
  border-radius: 4px;
}
.mask::-webkit-scrollbar-track {
  width: 8px;
  border-radius: 4px;
}
.mask::-webkit-scrollbar-thumb {
  width: 8px;
  background-color: #4961a3;
  border-radius: 4px;
}

.ml {
  margin-left: .5em;
}
</style>